import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { PROVISIONAL_OFFER_FAQ_ITEM } from '../../../../constants/heapEvents';
import { track } from '../../../../lib/heapHelpers';

import './index.scss';

const OfferFAQItem = ({ expanded = false, question, answer, applicationId, customerGuid }) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

  const handleFaqItemClick = () => {
    setIsExpanded(!isExpanded);
    track(PROVISIONAL_OFFER_FAQ_ITEM, {
      'Application GUID': applicationId,
      'Customer GUID': customerGuid,
      'FAQ item': question,
      'FAQ item expanded': !isExpanded,
    });
  };

  return (
    <div className="faq-item">
      <div className="faq-item__question" onClick={handleFaqItemClick}>
        <h4>{question}</h4>
        <div
          className={`faq-item__expand-icon ${isExpanded ? 'chevron-up' : 'chevron-down'}`}
        ></div>
      </div>
      <div
        className={`faq-item__answer ${isExpanded ? 'answer-open' : ''}`}
        data-testid="faq-item-answer"
      >
        <div className="answer-text">{answer}</div>
      </div>
    </div>
  );
};

OfferFAQItem.propTypes = {
  expanded: PropTypes.bool,
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  applicationId: PropTypes.string.isRequired,
  customerGuid: PropTypes.string.isRequired,
};

export default OfferFAQItem;
